import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMap from 'highcharts/modules/map';
import mapData from '@highcharts/map-collection/custom/europe.geo.json';

import COLORS from '../../core/constants/colors';
import { NaturalGasStorageMap } from '../../core/models/gas';

highchartsMap(Highcharts);

interface IGasByContryMapChart {
  data: NaturalGasStorageMap[];
}

/* eslint-disable react/no-this-in-sfc */
const GasByContryMapChart = React.memo(function GasByContryMapChart({
  data,
}: IGasByContryMapChart): JSX.Element {
  const chartData: [string, number][] = data.map((country) => [
    country.code_Country.toLowerCase(),
    country.market_Value,
  ]);

  // const chartData = data.map(
  //   (country) =>
  //     ({
  //       drilldown: country.code_Country.toLowerCase(),
  //       value: country.market_Value,
  //     } as SeriesMapDataOptions)
  // );

  const options: Highcharts.Options = {
    chart: {
      map: 'custom/europe',
      height: '100%',
      borderColor: undefined,
      animation: false,

      events: {
        load: function zoom() {
          this.mapZoom(0.55, 2300, 10000);
        },
      },
    },
    credits: {
      enabled: false,
    },

    title: {
      text: undefined,
    },

    subtitle: {
      text: undefined,
    },

    legend: {
      enabled: true,
      floating: true,
      itemMarginBottom: 20,
      align: 'center',
      symbolHeight: 8,
      symbolRadius: 0,
    },

    colorAxis: {
      tickAmount: 0,
      min: 0,
      max: 100,
      stops: [
        [0, COLORS.red],
        [0.5, COLORS.orangeChart],
        [1, COLORS.greenChart],
      ],
      labels: {
        enabled: false,
      },
    },

    plotOptions: {
      map: {
        borderColor: COLORS.white,
        nullColor: COLORS.nullContry,
      },
      series: {
        color: COLORS.nullContry,
        animation: false,
      },
    },

    mapNavigation: {
      enabled: false,
      enableButtons: false,
    },

    series: [
      {
        name: 'Country',
        type: 'map',
        mapData,
        data: [...chartData],
        dataLabels: {
          enabled: true,
          useHTML: true,
          format: undefined,
          formatter: function formatter() {
            const { color } = this.point;
            if (this.point.value) {
              return `
              <div style="color: ${color}; border: 1px solid ${color};" class="formatterGas">
                ${Number(this.point.value.toFixed(2))}%
              </div>
              `;
            }

            return '';
          },
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '{point.name}',
        },
      },
    ],
  };

  return (
    <div className="MapChart">
      <h3 className="text-center">Natural Gas Storage by Country</h3>
      <div className="MapChart__wrapper">
        <HighchartsReact constructorType="mapChart" highcharts={Highcharts} options={options} />
      </div>
    </div>
  );
});

export default GasByContryMapChart;
